import type {
  LiveChatConfigDTO,
  LiveChatMessageDTO,
  LiveChatSessionDTO,
  LiveChatSessionStatus,
  LiveChatStatusDTO,
  SendLiveChatAgentReplyDTO,
  UpdateLiveChatConfigDTO,
} from '@scrambl/shared'

import { apiClient } from './api-client'

export const liveChatApi = {
  // Config
  getConfig: () => apiClient<LiveChatConfigDTO>('/live-chat/config'),
  updateConfig: (body: UpdateLiveChatConfigDTO) =>
    apiClient<LiveChatConfigDTO>('/live-chat/config', { method: 'PUT', body }),

  // Presence + status
  getStatus: () => apiClient<LiveChatStatusDTO>('/live-chat/status'),
  getUnreadCount: () => apiClient<{ count: number }>('/live-chat/unread-count'),
  sendPresenceHeartbeat: () =>
    apiClient<{ ok: boolean }>('/live-chat/presence', { method: 'POST' }),

  // Sessions
  listSessions: (status?: LiveChatSessionStatus) =>
    apiClient<LiveChatSessionDTO[]>(
      `/live-chat/sessions${status ? `?status=${status}` : ''}`,
    ),
  getSessionMessages: (sessionId: string) =>
    apiClient<LiveChatMessageDTO[]>(
      `/live-chat/sessions/${sessionId}/messages`,
    ),
  sendAgentReply: (sessionId: string, body: SendLiveChatAgentReplyDTO) =>
    apiClient<LiveChatMessageDTO>(`/live-chat/sessions/${sessionId}/messages`, {
      method: 'POST',
      body,
    }),
  setTyping: (sessionId: string, isTyping: boolean) =>
    apiClient<{ ok: boolean }>(`/live-chat/sessions/${sessionId}/typing`, {
      method: 'POST',
      body: { isTyping },
    }),
  closeSession: (sessionId: string) =>
    apiClient<LiveChatSessionDTO>(`/live-chat/sessions/${sessionId}/close`, {
      method: 'POST',
    }),
  createTicket: (sessionId: string) =>
    apiClient<LiveChatSessionDTO>(
      `/live-chat/sessions/${sessionId}/create-ticket`,
      {
        method: 'POST',
      },
    ),
}
